import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-panel__row"
}
const _hoisted_2 = { class: "p-ticketSelection__feePitch" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "p-ticketSelection__recaptcha m-panel__row"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", { href: "https://policies.google.com/privacy" }, "Privacy Policy", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", { href: "https://policies.google.com/terms" }, "Terms of Service", -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "m-panel__row" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "m-panel__row"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { key: 3 }
const _hoisted_21 = {
  key: 1,
  class: "m-panel__row"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "m-panel__row" }
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_Panel, {
      state: _ctx.importantInformationState,
      class: "p-ticketSelection__additionalInfo"
    }, {
      default: _withCtx(() => [
        (_ctx.canDisplayFeeInformation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(" *  "),
                _withDirectives(_createElementVNode("h4", null, null, 512), [
                  [_directive_translate, {
                     key: _ctx.Translation.Ticket_fee_pitch,
                     keyValues: JSON.stringify({ 'placeholder-fee-values': _ctx.ticketFeeFormattedValues() }),
                     identifierStart: '{var}',
                     identifierEnd: '{/var}',
                     }]
                ])
              ]),
              _createElementVNode("p", {
                innerHTML: _ctx.composeTicketFeeDescriptionFrom(_ctx.data.feeList ?? [], _ctx.baseTicketFeeDescription)
              }, null, 8, _hoisted_3),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.feeList, (ticketFee) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: ticketFee.value,
                  innerHTML: ticketFee.description
                }, null, 8, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.configuration.reCaptcha.key)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(" This site is protected by reCAPTCHA and the Google "),
              _hoisted_6,
              _createTextVNode(" and "),
              _hoisted_7,
              _createTextVNode(" apply. ")
            ])), [
              [_directive_translate, { key: _ctx.Translation.Recaptcha_terms_conditions }]
            ])
          : _createCommentVNode("", true),
        (_ctx.data.additionalInformation.performanceDescription)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              innerHTML: _ctx.data.additionalInformation.performanceDescription,
              class: "m-panel__row a-editedContent"
            }, null, 8, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.data.eventInformation.eventType === _ctx.eventType.Voucher)
            ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_10, null, 512)), [
                [_directive_translate, { key: _ctx.Translation.Reservation_notice_voucher }]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_11, null, 512)), [
                [_directive_translate, {
                            key: _ctx.Translation.Reservation_notice_common,
                            keyValues: JSON.stringify({ max_tickets: _ctx.data.eventInformation.maxTickets })
                        }]
              ])
        ])
      ]),
      _: 1
    }, 8, ["state"]), [
      [_vShow, !_ctx.displayStateStore.isFullScreenSeatmap(_ctx.data)]
    ]),
    (_ctx.displayStateStore.hasAdditionalInformation)
      ? _withDirectives((_openBlock(), _createBlock(_component_Panel, {
          key: 0,
          class: "p-ticketSelection__additionalInfo",
          state: _ctx.additionalInformationState,
          onToggle: _ctx.updateAdditionalInformationState
        }, {
          default: _withCtx(() => [
            (_ctx.data.additionalInformation.promoter && _ctx.data.additionalInformation.promoter.name && _ctx.data.additionalInformation.promoter.name !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("h3", null, null, 512), [
                    [_directive_translate, { key: _ctx.Translation.Performance_promoter_information }]
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_ctx.data.additionalInformation.promoter.name), 1),
                  (_ctx.data.additionalInformation.promoter.street
                          || _ctx.data.additionalInformation.promoter.postalNumber
                          || _ctx.data.additionalInformation.promoter.city
                          || _ctx.data.additionalInformation.promoter.country)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        (_ctx.data.additionalInformation.promoter.street)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.data.additionalInformation.promoter.street), 1))
                          : _createCommentVNode("", true),
                        _hoisted_15,
                        (_ctx.data.additionalInformation.promoter.postalNumber)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.data.additionalInformation.promoter.postalNumber), 1))
                          : _createCommentVNode("", true),
                        _hoisted_17,
                        (_ctx.data.additionalInformation.promoter.city)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.data.additionalInformation.promoter.city), 1))
                          : _createCommentVNode("", true),
                        _hoisted_19,
                        (_ctx.data.additionalInformation.promoter.country)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.data.additionalInformation.promoter.country.translatedName), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.data.additionalInformation.fanTicket.isAvailable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("img", {
                    src: _ctx.data.additionalInformation.fanTicket.imgUrl,
                    alt: 'Fan Ticket'
                  }, null, 8, _hoisted_22),
                  _withDirectives((_openBlock(), _createElementBlock("div", null, [
                    _createTextVNode("FanTicket information")
                  ])), [
                    [_directive_translate, { key: _ctx.Translation.Fan_ticket_information }]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["state", "onToggle"])), [
          [_vShow, !_ctx.displayStateStore.isFullScreenSeatmap(_ctx.data)]
        ])
      : _createCommentVNode("", true),
    (_ctx.data.additionalInformation.accessibilityInformation
                               && _ctx.data.additionalInformation.accessibilityInformation !== ''
                               && _ctx.data.eventInformation.eventType !== _ctx.eventType.Voucher)
      ? _withDirectives((_openBlock(), _createBlock(_component_Panel, {
          key: 1,
          class: "p-ticketSelection__additionalInfo",
          state: _ctx.accessibilityInformationState,
          onToggle: _ctx.updateAccessibilityInformationState
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", null, [
                _withDirectives(_createElementVNode("a", {
                  class: "text-link",
                  href: _ctx.data.additionalInformation.accessibilityInformation,
                  rel: "external"
                }, null, 8, _hoisted_24), [
                  [_directive_translate, { key: _ctx.Translation.Accessibility_more_information }]
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["state", "onToggle"])), [
          [_vShow, !_ctx.displayStateStore.isFullScreenSeatmap(_ctx.data)]
        ])
      : _createCommentVNode("", true)
  ], 64))
}